// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"J8-z"};